// test1193
(1193 && 0);
